import { useState, useEffect, useRef } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"

const useListProject = () => {
    const [phases, setPhases] = useState([])
    const [projects, setProject] = useState([])
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const changePage = async (page) => {
        await getListProject(page)
        setPage(page)
    }
    const [loadingPagestate, setLoadingPage] = useState(false)

    const [limit, setLimit] = useState(10)
    const [filterName, setFilterName] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const debounceTimeout = useRef(null)

    const setFilterNameUser = (e) => {
        const value = e.target.value
        setSearchInput(value)

        // Clear existing timeout
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current)
        }

        // Set new timeout for 500ms
        debounceTimeout.current = setTimeout(() => {
            setFilterName(value)
            setPage(1)
        }, 500)
    }

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current)
            }
        }
    }, [])

    const setFilterLimit = (data) => {
        setLimit(data)
        setPage(1)
    }

    const getListPhase = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get('/auth/phases')
            setPhases(res.data.data)
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getListProject = async (page) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects?name=${filterName}`)
            setProject(res.data.data)
            setTotalPage(res.data.paging.TotalPages)
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteProject = async (id) => {
        try {
            let res = await axiosInstance.delete(`/auth/projects/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Project")
                // Refresh the list without full page reload
                await getListProject(page)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        phases,
        projects,
        getListPhase,
        getListProject,
        page,
        changePage,
        totalPage,
        deleteProject,
        setFilterNameUser,
        limit,
        filterName,
        searchInput,
        setFilterLimit,
        loadingPagestate
    }
}

export default useListProject